export default __webpack_public_path__ + "static/FreeStayMock-4bedf80b0a7f9c9b44b7d1a23b1220ab.png";